module.exports = __webpack_public_path__ + "static/media/footrise-45.ee9ed4f9.png";